import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Button } from "react-bootstrap";
import { FaFacebookF } from "react-icons/fa"; // Import Facebook icon
import "./RightSection.css";
import carImage from "./assets/car.png";
import samoaFlag from "./assets/samoa.png";
import thailandFlag from "./assets/thailand.png";
import micronesiaFlag from "./assets/micronesia.webp";
import kiribatiFlag from "./assets/kiribati.webp";
import guyanaFlag from "./assets/guyana.webp";
import tongaFlag from "./assets/tonga.png";
import jamaicaFlag from "./assets/jamaica.png";
import englandFlag from "./assets/england.png";
import grenadaFlag from "./assets/grenada.webp";
import philippineFlag from "./assets/philippine.webp";
import fijiFlag from "./assets/fiji.webp";
import chileFlag from "./assets/chile.png";
import newzealandFlag from "./assets/newzealand.webp";
import durbanFlag from "./assets/durban.png";
import pakistanFlag from "./assets/pakistan.webp";
import australiaFlag from "./assets/australia.webp";
import srilankaFlag from "./assets/srilanka.webp";
import southamptonFlag from "./assets/southampton.webp";
import caymanislandFlag from "./assets/cayman-island.png";
import saintvincentFlag from "./assets/saint-vincent.png";
import bahamasFlag from "./assets/bahamas.png";
import antiguaFlag from "./assets/antigua.png";
import saintluciaFlag from "./assets/saint-lucia.png";
import tanzaniaFlag from "./assets/tanzania.png";


console.log("RightSection mounted");
const countries = [
  { name: "JAMAICA", flag: jamaicaFlag },
  { name: "GRENADA", flag: grenadaFlag },
  { name: "CAYMAN ISLAND", flag: caymanislandFlag },
  { name: "SAINT VINCENT", flag: saintvincentFlag },
  { name: "GUYANA", flag: guyanaFlag },
  { name: "BAHAMAS", flag: bahamasFlag },
  { name: "ANTIGUA", flag: antiguaFlag },
  { name: "SAINT LUCIA", flag: saintluciaFlag },
  { name: "TANZANIA", flag: tanzaniaFlag },
  { name: "SAMOA", flag: samoaFlag },
  { name: "THAILAND", flag: thailandFlag },
  { name: "MICRONESIA", flag: micronesiaFlag },
  { name: "KIRIBATI", flag: kiribatiFlag },
  { name: "TONGA", flag: tongaFlag },
  { name: "ENGLAND", flag: englandFlag },
  { name: "PHILIPPINE", flag: philippineFlag },
  { name: "FIJI", flag: fijiFlag },
  { name: "CHILE", flag: chileFlag },
  { name: "NEW ZEALAND", flag: newzealandFlag },
  { name: "DURBAN", flag: durbanFlag },
  { name: "PAKISTAN", flag: pakistanFlag },
  { name: "AUSTRALIA", flag: australiaFlag },
  { name: "SRI LANKA", flag: srilankaFlag },
  { name: "UK SOUTHAMPTON", flag: southamptonFlag },
];

const RightSection = () => {
  const [selectedMaker, setSelectedMaker] = useState('');
  const [selectedModel, setSelectedModel] = useState('');
  const [models, setModels] = useState([]);
  const [makers, setMakers] = useState([]);
  const [selectedYearFrom, setSelectedYearFrom] = useState('');
  const [years, setYears] = useState([]); // For year dropdown options
  const [selectedYearTo, setSelectedYearTo] = useState('');
  const [selectedPriceFrom, setSelectedPriceFrom] = useState('');
  const [prices, setPrices] = useState([]); // For price dropdown options
  const [selectedPriceTo, setSelectedPriceTo] = useState('');
  const [selectedVin, setSelectedVin] = useState('');
  const [vins, setVins] = useState([]); // For VIN dropdown
  const [selectedMileage, setSelectedMileage] = useState('');
  const [mileages, setMileages] = useState([]); // For Mileage dropdown
  const [selectedFuel, setSelectedFuel] = useState('');
  const [fuels, setFuels] = useState([]); // For Fuel dropdown
  const [selectedTransmission, setSelectedTransmission] = useState('');
  const [transmissions, setTransmissions] = useState([]); // For Transmission dropdown
  const [selectedBodyType, setSelectedBodyType] = useState('');
  const [bodyTypes, setBodyTypes] = useState([]); // For Body Type dropdown
  const [selectedColor, setSelectedColor] = useState('');
  const [colors, setColors] = useState([]); // For Color dropdown
  const navigate = useNavigate(); // Initialize useNavigate

  // Handle country click and redirect to SearchIndividual with criteria=country
  const handleCountryClick = (countryName) => {
    console.log("Criteria: country, Value:", countryName); // Debugging
    navigate(`/search-individual?criteria=country&value=${encodeURIComponent(countryName)}`);
  };


  useEffect(() => {
    // Fetch makers
    fetch('https://skcapi.btcjapan.co/getDropdownOptions.php')
      .then(response => response.json())
      .then(data => setMakers(data))
      .catch(error => console.error('Error fetching makers:', error));

    // Fetch years for the "Year From" and "Year To" dropdowns
    fetch('https://skcapi.btcjapan.co/getYears.php')
      .then(response => response.json())
      .then(data => setYears(data))
      .catch(error => console.error('Error fetching years:', error));

    // Fetch prices for the "Price From" and "Price To" dropdowns
    fetch('https://skcapi.btcjapan.co/getPrices.php')
      .then(response => response.json())
      .then(data => setPrices(data))
      .catch(error => console.error('Error fetching prices:', error));

    // Fetch VINs
    fetch('https://skcapi.btcjapan.co/getVins.php')
      .then(response => response.json())
      .then(data => setVins(data))
      .catch(error => console.error('Error fetching VINs:', error));

    // Fetch Mileages
    fetch('https://skcapi.btcjapan.co/getMileages.php')
      .then(response => response.json())
      .then(data => setMileages(data))
      .catch(error => console.error('Error fetching mileages:', error));

    // Fetch Fuels
    fetch('https://skcapi.btcjapan.co/getFuels.php')
      .then(response => response.json())
      .then(data => setFuels(data))
      .catch(error => console.error('Error fetching fuels:', error));

    // Fetch Transmissions
    fetch('https://skcapi.btcjapan.co/getTransmissions.php')
      .then(response => response.json())
      .then(data => setTransmissions(data))
      .catch(error => console.error('Error fetching transmissions:', error));

    // Fetch Body Types
    fetch('https://skcapi.btcjapan.co/getBodyTypes.php')
      .then(response => response.json())
      .then(data => setBodyTypes(data))
      .catch(error => console.error('Error fetching body types:', error));

    // Fetch Colors
    fetch('https://skcapi.btcjapan.co/getColors.php')
      .then(response => response.json())
      .then(data => setColors(data))
      .catch(error => console.error('Error fetching colors:', error));
  }, []);

  const handleMakerChange = (event) => {
    const maker = event.target.value;
    setSelectedMaker(maker);
    setSelectedModel(''); // Reset model when maker changes
    fetch(`https://skcapi.btcjapan.co/getModels.php?maker=${maker}`)
      .then(response => response.json())
      .then(data => setModels(data))
      .catch(error => console.error('Error fetching models:', error));
  };

  const handleModelChange = (event) => {
    setSelectedModel(event.target.value);
  };

  const handleYearFromChange = (event) => {
    setSelectedYearFrom(event.target.value);
  };

  const handleYearToChange = (event) => {
    setSelectedYearTo(event.target.value);
  };

  const handlePriceFromChange = (event) => {
    setSelectedPriceFrom(event.target.value);
  };

  const handlePriceToChange = (event) => {
    setSelectedPriceTo(event.target.value);
  };

  const handleVinChange = (event) => {
    setSelectedVin(event.target.value);
  };

  const handleMileageChange = (event) => {
    setSelectedMileage(event.target.value);
  };

  const handleFuelChange = (event) => {
    setSelectedFuel(event.target.value);
  };

  const handleTransmissionChange = (event) => {
    setSelectedTransmission(event.target.value);
  };

  const handleBodyTypeChange = (event) => {
    setSelectedBodyType(event.target.value);
  };

  const handleColorChange = (event) => {
    setSelectedColor(event.target.value);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    navigate('/search-result', {
      state: {
        maker: selectedMaker,
        model: selectedModel,
        yearFrom: selectedYearFrom,
        yearTo: selectedYearTo,
        priceFrom: selectedPriceFrom,
        priceTo: selectedPriceTo,
        vin: selectedVin,
        mileage: selectedMileage,
        fuel: selectedFuel,
        transmission: selectedTransmission,
        bodyType: selectedBodyType,
        color: selectedColor,
      },
    });
  };

  return (
    <div className="right-section">

      <div className="search-section">
        <h2 className="mb-3">Find your perfect car</h2>

        <form onSubmit={handleSearch}>
          <div className="row">
            {/* Maker Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="make" className="form-label text-black">Maker</label>
              <select id="make" className="form-select" onChange={handleMakerChange}>
                <option value="">Select</option>
                {makers.map((maker, index) => (
                  <option key={index} value={maker}>{maker}</option>
                ))}
              </select>
            </div>

            {/* Model Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="model" className="form-label text-black">Model</label>
              <select id="model" className="form-select" onChange={handleModelChange}>
                <option value="">Select</option>
                {models.map((model, index) => (
                  <option key={index} value={model}>{model}</option>
                ))}
              </select>
            </div>

            {/* Year From Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="yearFrom" className="form-label text-black">Year From</label>
              <select id="yearFrom" className="form-select" onChange={handleYearFromChange}>
                <option value="">Select</option>
                {years.map((year, index) => (
                  <option key={index} value={year}>{year}</option>
                ))}
              </select>
            </div>

            {/* Year To Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="yearTo" className="form-label text-black">Year To</label>
              <select id="yearTo" className="form-select" onChange={handleYearToChange}>
                <option value="">Select</option>
                {years.map((year, index) => (
                  <option key={index} value={year}>{year}</option>
                ))}
              </select>
            </div>

            {/* Price From Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="priceFrom" className="form-label text-black">Price From</label>
              <select id="priceFrom" className="form-select" onChange={handlePriceFromChange}>
                <option value="">Select</option>
                {prices.map((price, index) => (
                  <option key={index} value={price}>{price}</option>
                ))}
              </select>
            </div>

            {/* Price To Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="priceTo" className="form-label text-black">Price To</label>
              <select id="priceTo" className="form-select" onChange={handlePriceToChange}>
                <option value="">Select</option>
                {prices.map((price, index) => (
                  <option key={index} value={price}>{price}</option>
                ))}
              </select>
            </div>

            {/* VIN Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="vin" className="form-label text-black">VIN</label>
              <select id="vin" className="form-select" onChange={handleVinChange}>
                <option value="">Select</option>
                {vins.map((vin, index) => (
                  <option key={index} value={vin}>{vin}</option>
                ))}
              </select>
            </div>

            {/* Mileage Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="mileage" className="form-label text-black">Mileage</label>
              <select id="mileage" className="form-select" onChange={handleMileageChange}>
                <option value="">Select</option>
                {mileages.map((mileage, index) => (
                  <option key={index} value={mileage}>{mileage}</option>
                ))}
              </select>
            </div>

            {/* Fuel Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="fuel" className="form-label text-black">Fuel</label>
              <select id="fuel" className="form-select" onChange={handleFuelChange}>
                <option value="">Select</option>
                {fuels.map((fuel, index) => (
                  <option key={index} value={fuel}>{fuel}</option>
                ))}
              </select>
            </div>

            {/* Transmission Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="transmission" className="form-label text-black">Transmission</label>
              <select id="transmission" className="form-select" onChange={handleTransmissionChange}>
                <option value="">Select</option>
                {transmissions.map((transmission, index) => (
                  <option key={index} value={transmission}>{transmission}</option>
                ))}
              </select>
            </div>

            {/* Body Type Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="bodyType" className="form-label text-black">Body Type</label>
              <select id="bodyType" className="form-select" onChange={handleBodyTypeChange}>
                <option value="">Select</option>
                {bodyTypes.map((bodyType, index) => (
                  <option key={index} value={bodyType}>{bodyType}</option>
                ))}
              </select>
            </div>

            {/* Color Dropdown */}
            <div className="col-lg-12 col-md-3 col-sm-4 col-6">
              <label htmlFor="color" className="form-label text-black">Color</label>
              <select id="color" className="form-select" onChange={handleColorChange}>
                <option value="">Select</option>
                {colors.map((color, index) => (
                  <option key={index} value={color}>{color}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Search Button */}
          <div className="container mt-2">
            <div className="row">
              <div className="col text-end">
                <button type="submit" className="btn btn-primary">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="searchicon" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                  Search
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>


      <div className="newsletter-header">
        <h2>EVERY WEEK</h2>
        <h1>NEWSLETTER</h1>
        <img
          src={carImage}
          alt="Car"
          className="car-image"
          onError={(e) => {
            console.log("Car image failed to load", e);
            e.target.style.display = "none";
          }}
        />
        <ul className="feature-list">
          <li>Updates</li>
          <li>Transparent Pricing</li>
          <li>Hassle-Free Process</li>
        </ul>
        <Button variant="warning" className="subscribe-btn">
          SUBSCRIBE NOW
        </Button>
      </div>
      <div className="newsletter-content">
        <h3>Newsletter</h3>
        <ul className="bullet-list">
          <li>Now operating in your country</li>
          <li>Signup for 20% instant discount</li>
          <li>Subscribe for latest updates</li>
        </ul>
        <div className="country-section">
          <p>SKC Japan is in your country now</p>

          <ul className="country-list">
            {countries.map((country, index) => (
              <li key={index} className="country-item" onClick={() => handleCountryClick(country.name)}>
                <img
                  src={country.flag}
                  alt={`${country.name} flag`}
                  className="country-flag"
                  onError={(e) => {
                    console.log(`${country.name} flag failed to load`, e);
                    e.target.style.display = "none";
                  }}
                />
                <span className="country-name">{country.name}</span>
              </li>
            ))}
          </ul>

        </div>
        <div className="facebook-section">
          <div className="facebook-info">
            <FaFacebookF className="facebook-icon" />
            <span className="facebook-name">SKC Japan</span>
          </div>
          <Button variant="outline-dark" className="follow-btn">
            Follow Us
          </Button>
        </div>
      </div>

    </div>
  );
};

export default RightSection;